import { useFinancialData, SCENARIO_CONFIG } from '../../context/FinancialDataContext';

// Small pill in the header showing the active forecast scenario.
// Acts as a visual reminder that all forecasts on every page use this setting.
export default function ScenarioBadge() {
  const { forecastScenario, setForecastScenario } = useFinancialData();
  const cfg = SCENARIO_CONFIG[forecastScenario] || SCENARIO_CONFIG.normal;

  const colors = {
    conservative: 'bg-rose/20 text-rose hover:bg-rose/30',
    normal: 'bg-white/15 text-white hover:bg-white/25',
    aggressive: 'bg-deep-teal/30 text-white hover:bg-deep-teal/40',
  };

  // Cycle through scenarios on click for quick switching
  function cycle() {
    const order = ['conservative', 'normal', 'aggressive'];
    const next = order[(order.indexOf(forecastScenario) + 1) % order.length];
    setForecastScenario(next);
  }

  return (
    <button
      onClick={cycle}
      className={`px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider rounded-[4px] transition-colors ${colors[forecastScenario] || colors.normal}`}
      title={`Forecast scenario: ${cfg.label}. Click to cycle. Affects Smart Forecast, P&L projections, and downstream calculations.`}
    >
      {cfg.label} Forecast
    </button>
  );
}
